import ApiService from 'utils/ApiCalls';
import { useSelector } from 'react-redux';
import { notification } from 'antd';

const useFetchContractualInformation = () => {
  const {
    selectedBranchForContractualInformation,
    selectedICTForContractualInformation,
    selectedTPPForContractualInformation,
    selectedEntityForContractualInformation,
  } = useSelector((state: any) => state.contractualInformation);

  const fetchContractualInformation = async () => {
    try {
      const response = await ApiService.fetchContractualInformation(
        selectedBranchForContractualInformation,
        selectedICTForContractualInformation,
        selectedTPPForContractualInformation,
        selectedEntityForContractualInformation,
      );
      return response;
    } catch (error) {
      console.log('Error fetching Contractual Information:', error);
      throw error;
    }
  };

  return fetchContractualInformation;
};

const postContractualInformation = async (contractualInformation: any) => {
  try {
    const response = await ApiService.postContractualInformation(
      contractualInformation,
    );
    notification.success({
      message: 'Info',
      description: response.data.message,
      duration: 10,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

const fetchBranchesbyEntityName = async (entityTypeData: any) => {
  try {
    const response = await ApiService.postBranchesbyEntityName(entityTypeData);
    return response;
  } catch (error) {
    console.log('Error fetching the Branches:', error);
  }
};

const fetchICTServicesbyEntityName = async (entityTypeData: any) => {
  try {
    const response =
      await ApiService.postICTServicesbyEntityName(entityTypeData);
    return response;
  } catch (error) {
    console.log('Error fetching the ICT services:', error);
  }
};

const fetchTerminatReasons = async () => {
  try {
    const response = await ApiService.getTerminatReasons();
    return response;
  } catch (error) {
    console.log('Error fetching the terminat reasons:', error);
  }
};

const fetchContractualArrangementTypes = async (entity_id: any) => {
  try {
    const response = await ApiService.getContractualArrangementTypes(entity_id);
    return response;
  } catch (error) {
    console.log('Error fetching the contractual arrangement types:', error);
  }
};

const fetchListOfContractualArrangements = async () => {
  try {
    const response = await ApiService.getListOfContractualArrangements();
    return response;
  } catch (error) {
    console.log('Error fetching contractual arrangements:', error);
  }
};

const fetchListOfContractualArrangementsByEntity = async (
  entity_id: number,
) => {
  try {
    const response =
      await ApiService.getListOfContractualArrangementsByEntity(entity_id);
    return response;
  } catch (error) {
    console.log('Error fetching contractual arrangements by entity:', error);
    throw error;
  }
};

const insertContractualDetails = async (payload: any) => {
  try {
    const response = await ApiService.postContractualInformation(payload);
    return response;
  } catch (error) {
    console.log('Error inserting contractual details:', error);
    throw error;
  }
};

export default {
  useFetchContractualInformation,
  fetchBranchesbyEntityName,
  fetchICTServicesbyEntityName,
  postContractualInformation,
  fetchTerminatReasons,
  fetchContractualArrangementTypes,
  fetchListOfContractualArrangements,
  fetchListOfContractualArrangementsByEntity,
  insertContractualDetails,
};
